<div class="grid flex header-gap">
  @if (accountStatus$ | async; as accountStatus) {
    @if (accountStatus === accountStatusActive) {
      <div class="grid w-full pb-5">
        <div class="md:col-9">
          <h1 class="header">{{ 'Header.Accounts' | translate }}</h1>
          <div class="yellow-underline"></div>
        </div>
        <div class="md:col-3">
          <div class="justify-content-end align-items-end flex">
            <p-button
              icon="pi pi-plus"
              label="{{ 'Accounts.NewAccount' | translate }}"
              styleClass="p-button-rounded"
              class="p-2 pr-0"
              (onClick)="addAccount()" />
          </div>
        </div>
      </div>

      <div class="grid w-full pb-5">
        <div class="md:col-10 pr-0">
          <div class="grid w-full">
            <div class="md:col-3">
              <div class="flex flex-column">
                <label class="input-label" htmlFor="">{{ 'Accounts.Name' | translate }}</label>
                <span class="p-input-icon-right">
                  <input
                    type="text"
                    pInputText
                    id="filterByName"
                    [(ngModel)]="filterByName"
                    styleClass="w-full"
                    class="w-full" />
                </span>
              </div>
            </div>
            <div class="md:col-3">
              <div class="flex flex-column">
                <label class="input-label" htmlFor="">{{ 'Accounts.Email' | translate }}</label>
                <span class="p-input-icon-right">
                  <input
                    type="text"
                    pInputText
                    id="filterByEmail"
                    [(ngModel)]="filterByEmail"
                    styleClass="w-full"
                    class="w-full" />
                </span>
              </div>
            </div>
            <div class="md:col-3">
              <div class="flex flex-column">
                <label class="input-label" htmlFor="">{{ 'Accounts.Role' | translate }}</label>
                <p-select
                  id="filterByRole"
                  [(ngModel)]="filterByRole"
                  styleClass="w-full"
                  [options]="roleFilterOptions"
                  optionValue="value" />
              </div>
            </div>
            <div class="md:col-3">
              <div class="flex flex-column">
                <label class="input-label" htmlFor="">{{ 'Accounts.Status' | translate }}</label>
                <p-select
                  id="filterByLinkStatus"
                  [(ngModel)]="filterByLinkStatus"
                  styleClass="w-full"
                  [options]="linkStatusFilterOptions"
                  optionValue="value" />
              </div>
            </div>
          </div>
        </div>
        <div class="md:col-2 pl-0 align-items-end flex">
          <p-button
            icon="pi pi-times"
            pTooltip="{{ 'Accounts.Clear' | translate }}"
            tooltipPosition="top"
            styleClass="p-button-outlined p-button-md"
            class="p-2 pl-0"
            [loading]="clearInProgress"
            (onClick)="onClear()" />
          <p-button
            icon="pi pi-search"
            pTooltip="{{ 'Accounts.Search' | translate }}"
            tooltipPosition="top"
            styleClass="p-button p-button-md"
            class="p-2"
            [loading]="searchInProgress"
            (onClick)="onSearch()" />
        </div>
      </div>

      <div class="grid w-full">
        @if (customersState$ | async; as state) {
          <p-table
            class="w-full"
            [value]="customers"
            class="w-full"
            dataKey="id"
            [lazy]="true"
            (onLazyLoad)="loadCustomers($event)"
            [paginator]="true"
            [rows]="pageSize"
            [first]="firstRowIndex"
            [totalRecords]="totalRecords"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="pageSizeOptions"
            [loading]="state.status === actionStatus.Pending"
            [sortField]="sortField"
            [sortOrder]="sortOrder">
            <ng-template pTemplate="header">
              <tr>
                <th id="created" pSortableColumn="created" class="uppercase text-gray-500 hidden" style="width: 0%">
                  {{ 'Customers.Date' | translate }}
                  <i
                    class="pi pl-1"
                    [class.pi-angle-up]="sortOrder === eSortOrder.ASC"
                    [class.pi-angle-down]="sortOrder !== eSortOrder.ASC"></i>
                </th>
                <th id="name" class="uppercase text-gray-500" style="width: 20%">
                  {{ 'Accounts.Name' | translate }}
                </th>
                <th id="details" class="uppercase text-gray-500" style="width: 40%">
                  {{ 'Accounts.Details' | translate }}
                </th>
                <th id="role" class="uppercase text-gray-500" style="width: 15%">
                  {{ 'Accounts.Role' | translate }}
                </th>
                <th id="linkStatus" class="uppercase text-gray-500" style="width: 15%">
                  {{ 'Accounts.LinkStatus' | translate }}
                </th>
                <th id="options" class="uppercase text-gray-500" style="width: 10%">
                  {{ 'Accounts.Options' | translate }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer>
              <tr>
                <td class="hidden">
                  {{ customer.created | date: dateFormat }}
                </td>
                <td>
                  <strong class="grid-coloum-field">
                    {{ (customer.lastName || '') + (customer.lastName ? ', ' : '') + (customer.firstName || '') }}
                  </strong>
                </td>
                <td>
                  <p class="my-2 grid-coloum-field font-normal">
                    {{ customer.email }}
                  </p>
                  <p class="my-2 grid-coloum-field font-normal">
                    {{ 'Accounts.DoctorID' | translate }}:
                    {{ customer.doctorId || 'N/A' }}
                  </p>
                </td>
                <td>
                  {{ customer.role || ('Accounts.Undefined' | translate) }}
                </td>
                <td>
                  @if (customer.customerOrganizationStatusId) {
                    <p-tag [class]="getCustomerStatusStyle(customer.customerOrganizationStatusId)">
                      <div class="flex align-items-center gap-2">
                        <span class="p-tag-text">{{
                          getCustomerStatusName(customer.customerOrganizationStatusId)
                        }}</span>
                      </div>
                    </p-tag>
                  }
                </td>
                <td>
                  <p-button
                    styleClass="p-button-secondary p-button-text "
                    icon="pi pi-ellipsis-h"
                    (onClick)="tieredMenu.toggle($event)" />
                  <p-tieredMenu
                    appendTo="body"
                    #tieredMenu
                    [model]="customer.customerMenuItems"
                    [popup]="true"
                    styleClass="tiered-menu" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8">{{ 'Order.NoResultsFound' | translate }}</td>
              </tr>
            </ng-template>
          </p-table>
        }
      </div>
    } @else {
      <div class="grid w-full pb-5">
        <div class="md:col-10">
          <h1 class="header">{{ 'Profile.LiteAccount' | translate }}</h1>
          <div class="yellow-underline"></div>
        </div>
        <div class="md:col-11">
          <p-message severity="info" icon="pi pi-info-circle">
            <div class="content-box">
              <span class="summary-txt">Info</span>
              <span>{{ 'Accounts.AccountNotActivated' | translate }}</span>
            </div>
          </p-message>
        </div>
      </div>
    }
  }
</div>
